import React from 'react';
import { FormControl, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

const GetPhoneNumber = ({ profileId, profile, handleActionChange, isOrgConnectedProfilesData }) => {
  const { t: translate } = useTranslation();
  return (
    <>
      <FormControl sx={{ minWidth: 120 }}>
        <Select
          value={profile.button_type}
          onChange={(event) => {
            handleActionChange(profileId, profile, event.target.value);
          }}
          displayEmpty
          inputProps={{ 'aria-label': 'Without label' }}
          size="small"
        >
          <MenuItem value={'None'}>{translate('post_conditions.button_none', 'None')}</MenuItem>
          <MenuItem value={'BOOK'}>{translate('post_conditions.button_book', 'Book')}</MenuItem>
          <MenuItem value={'ORDER'}>{translate('post_conditions.button_order', 'Order')}</MenuItem>
          <MenuItem value={'LEARN_MORE'}>{translate('post_conditions.button_learn_more', 'Learn More')}</MenuItem>
          <MenuItem value={'SIGN_UP'}>{translate('post_conditions.button_sign_up', 'Sign Up')}</MenuItem>
          {!isOrgConnectedProfilesData && profile?.connected_profile_details?.has_call_now_permission && (
            <MenuItem value={'CALL'}>{translate('post_conditions.button_call_now', 'Call Now')}</MenuItem>
          )}
        </Select>
      </FormControl>
    </>
  );
};

export default GetPhoneNumber;
